import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "calendarCheck"
const CalendarCheckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.44 13.875 22.94 15.158 16.326 22.875 11.625 18.175 13.02 16.778 16.214 19.972z" />
          <path
            fillRule="evenodd"
            d="M8.25 3.75H15.75V1.5H17.25V3.75H20.25C21.078 3.75 21.75 4.422 21.75 5.25V11.54L21.227 11.093 20.25 12.23V9.75H3.75V18.75H9.41L10.91 20.25H3.75L3.597 20.242C2.84 20.165 2.25 19.527 2.25 18.75V5.25C2.25 4.422 2.922 3.75 3.75 3.75H6.75V1.5H8.25zM3.75 8.25H20.25V5.25H17.25V6.75H15.75V5.25H8.25V6.75H6.75V5.25H3.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CalendarCheckIcon
